// import Header from "@/components/common/header";
// import Container from "@/components/Container";
// import Description from "@/components/home/Description";
// import FloatingImages from "@/components/home/FloatingImages";
// import MainTitle from "@/components/home/MainTitle";
// import SearchInput from "@/components/home/SearchInput";
// import Markdown from "@/components/result/leftside/content/MarkDown";
// import { useChatHistoryStore } from '@/store/chatHistoryStore';
// import { useHeaderStore } from '@/store/headerStore';
// import { useOptionStore } from '@/store/optionStore';
// import useOverViewStore from '@/store/overViewStore';
// import { useRedirectStore } from "@/store/redirectStore";
import { useSearchStore } from '@/store/searchStore';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import SeoHead, {
  DEFAULT_META_DESCRIPTION,
  DEFAULT_META_TITLE,
} from '../components/common/SeoHead';
// import axios from "axios";
// import useShutterstockSearch from '../hooks/useShutterstockSearch';
// import { useAuthStore } from '@/store/authStore';

export default function Home() {
  // const [query, setQuery] = useState<string>('');
  // const { images} = useShutterstockSearch(query);
  //  const {accessToken,setAccessToken,setRefreshToken} = useAuthStore();

  // const [chatHistory, setChatHistory] = useState<string>("");
  const {
    // isLoginRequired,
    // setLoginRequired,
    setSearchActive,
    // showLoginPopup,
    // setShowLoginPopup,
  } = useSearchStore();
  // const { setRedirectUrl } = useRedirectStore();
  const setSearchTypeActive = useSearchStore(
    state => state.setSearchTypeActive
  );

  const router = useRouter();
  // const {
  //   clearSearchHistory
  // } = useChatHistoryStore();
  //   const { resetHeader } = useHeaderStore();
  // const { clearData } = useOptionStore();
  // const { clearoverViewData,
  // } = useOverViewStore();

  // useEffect(() => {
  //   handleChat("kochi travelling plan");
  // }, []);
  useEffect(() => {
    // Make `/experiences` the landing (default) route
    router.replace('/experiences');
  }, [router]);

  useEffect(() => {
    setSearchTypeActive(false);
    // setQuery("basilica of bom jesus,goa");
  }, [setSearchTypeActive]);

  useEffect(() => {
    setSearchActive(false);
  }, [setSearchActive]);

  // const handleChat = async (message: string) => {
  //   console.log("handleChat message", message);
  //   try {
  //     const body = {
  //       user_id: "string",
  //       session_id: "string",
  //       message: message,
  //     };

  //     const response = await axios.post("/api/concierge", body);
  //     console.log("handleChat response", response);
  //     setChatHistory(response.data.response);
  //     console.log("chatHistory", chatHistory);
  //   } catch (error) {
  //     console.log("handleChat error", error);
  //     if (axios.isAxiosError(error)) {
  //       console.error("Error details:", error.response?.data || error.message);
  //     }
  //   }
  // };

  // const handleClosePopup = () => {
  //   setShowLoginPopup(false);
  //   setLoginRequired(false);
  // };

  // const handleGoToLogin = () => {
  //   setRedirectUrl(router.asPath);
  //   router.push("/login");
  //   setLoginRequired(true);
  //   setShowLoginPopup(false);
  // };

  // const getPopupMessage = () => {
  //   if (showLoginPopup) {
  //     return "please login to continue";
  //     // return "Continue to login for personalized travel assistance and experience.";
  //   } else if (isLoginRequired) {
  //     return "please login to continue";
  //     // "You've reached the limit of free conversations. Please login to continue.";
  //   }
  // };
  // useEffect(() => {
  //         setAccessToken(process.env.NEXT_PUBLIC_ACCESS_TOKEN);
  //         setRefreshToken(process.env.NEXT_PUBLIC_REFRESH_TOKEN);
  //        console.log("accessToken",accessToken)
  // }, [setAccessToken, setRefreshToken,accessToken]);
  //  useEffect(() => {
  //   clearData();
  //   clearoverViewData();
  //   resetHeader();
  //   clearSearchHistory();
  //   }, [clearoverViewData, clearSearchHistory,clearData,resetHeader]);

  return (
    <div>
      <SeoHead
        title={DEFAULT_META_TITLE}
        description={DEFAULT_META_DESCRIPTION}
        path='/'
        disableTitleSuffix
      />
      {/* {chatHistory ? <Markdown content={chatHistory} /> : null} */}

      {/* <div className="min-h-screen bg-background items-center justify-items-center ">
        <Container>
          <main className="min-h-screen flex flex-col">
            <Header />

            <div className="flex-1 flex flex-col items-center justify-center ">
              <div className="text-center relative mt-24">
                <FloatingImages
                  className="md:left-[1rem] md:top-[-15.94rem]  -top-[14rem] xs:left-[6rem] left-[4rem]"
                  height="lg:h-40 h-24"
                  width="lg:w-40 w-24"
                  src="/assets/images/home/home-1.png"
                  transitionDelay={1}
                />
                <FloatingImages
                  className="md:right-[35%] md:top-[-11.5rem] right-20 -top-[11.75rem]"
                  height="lg:h-[7.5rem] h-20"
                  width="lg:w-[7.5rem] w-20"
                  src="/assets/images/home/home-2.png"
                  transitionDelay={2}
                />
                <FloatingImages
                  className="lg:right-[-8.56rem] md:right-[-5.56rem] md:top-[-14.25rem] right-[6.6875rem] -top-[15.8125rem]"
                  height="lg:h-[5.4375rem] h-[3.3125rem]"
                  width="lg:w-[5.4375rem] w-[3.3125rem]"
                  src="/assets/images/home/home-3.png"
                  transitionDelay={3}
                />
                <FloatingImages
                  className="md:right-[-23.4375%] lg:bottom-[-12.94rem] md:bottom-[-9rem] bottom-[5rem] right-[5.94rem]"
                  height="lg:h-[8.75rem] h-[5.375rem]"
                  width="lg:w-[8.75rem]  w-[5.375rem]"
                  src="/assets/images/home/home-5.png"
                  transitionDelay={4}
                />
                <FloatingImages
                  className="lg:left-[-11.25rem] md:left-[-7.25rem]  lg:bottom-[-12.25rem] md:bottom-[-8.25rem] bottom-[5rem] xs:left-[3.75rem] left-[1.75rem]"
                  height="lg:h-[11.25rem]  h-[6.875rem]"
                  width="lg:w-[11.25rem] w-[6.875rem]"
                  src="/assets/images/home/home-4.png"
                  transitionDelay={0}
                />

                <MainTitle
                  highlight1="Next,"
                  highlight2="go"
                  normalText1=" where will you"
                  // normalText2="destination to"
                />
                <div className="flex justify-center w-full">
                  <Description text="I am here to help you plan your trip and answer any travel-related questions you have." />
                </div>
              </div>
            </div>
            <SearchInput />
          </main>
        </Container>

        {(showLoginPopup || isLoginRequired) && (
          <dialog open className="modal modal-open">
            <div className="modal-box">
              <h3 className="font-bold text-lg">Login Required</h3>
              <p className="py-4">{getPopupMessage()}</p>
              <div className="modal-action">
                {!isLoginRequired && (
                  <button
                    onClick={handleClosePopup}
                    className="btn btn-secondary text-xs border-none shadow-none hover:bg-white"
                  >
                    Not Now
                  </button>
                )}
                <button
                  onClick={handleGoToLogin}
                  className="btn btn-primary py-3 px-4"
                >
                  Login
                </button>
              </div>
            </div>
          </dialog>
        )}
      </div> */}
    </div>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', ['common'])),
    },
  };
};
